export type LengthUnit = 'cm' | 'mm' | 'ex' | 'pt';

export class Length {
  private readonly _space: number;
  private readonly _unit: LengthUnit;

  get space(): number {
    return this._space;
  }

  get unit(): LengthUnit {
    return this._unit;
  }

  constructor(space: number, unit: LengthUnit) {
    this._space = space;
    this._unit = unit;
  }
}
